import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "./userService";

// get user from local storage
const userInfo = JSON.parse(localStorage.getItem("userInfo"));

const initialState = {
  userInfo: userInfo ? userInfo : null,

  selectedUser: null,

  users: [],

  isCreateLoading: false,
  isCreateError: false,
  isCreateSuccess: false,
  createErrorMessage: "",

  isLoginLoading: false,
  isLoginError: false,
  isLoginSuccess: false,
  loginErrorMessage: "",

  isUpdateLoading: false,
  isUpdateError: false,
  isUpdateSuccess: false,
  updateErrorMessage: "",

  isGetUserByIdLoading: false,
  isGetUserByIdError: false,
  isGetUserByIdSuccess: false,
  getUserByIdErrorMessage: "",

  isGetAllUsersLoading: false,
  isGetAllUsersError: false,
  isGetAllUsersSuccess: false,
  getAllUsersErrorMessage: "",

  // isDetailsLoading: false,
  // isDetailsError: false,
  // isDetailsSuccess: false,
  // detailsErrorMessage: "",
};

//Create User
export const createUser = createAsyncThunk(
  "user/createUser",
  async (user, thunkAPI) => {
    try {
      const createdUser = await userService.createUser(user);
      return createdUser;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Login User
export const loginUser = createAsyncThunk(
  "user/loginUser",
  async (user, thunkAPI) => {
    try {
      const loggedInUser = await userService.loginUser(user);
      return loggedInUser;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update User
export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (data, thunkAPI) => {
    const { userData, id } = data;
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token;
      const updatedUser = await userService.updateUser(userData, id, token);
      return updatedUser;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get user by id
export const getUserById = createAsyncThunk(
  "user/getUserById",
  async (id, thunkAPI) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token;
      const user = await userService.getUserById(id, token);
      return user;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get all users
export const getAllUsers = createAsyncThunk(
  "user/getAllUsers",
  async (_, thunkAPI) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token;
      const users = await userService.getAllUsers(token);
      return users;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserCreate: (state) => {
      state.isCreateLoading = false;
      state.isCreateError = false;
      state.isCreateSuccess = false;
      state.createErrorMessage = "";
    },
    resetUserLogin: (state) => {
      state.isLoginLoading = false;
      state.isLoginError = false;
      state.isLoginSuccess = false;
      state.loginErrorMessage = "";
    },
    resetUserUpdate: (state) => {
      state.isUpdateLoading = false;
      state.isUpdateError = false;
      state.isUpdateSuccess = false;
      state.updateErrorMessage = "";
    },
    resetGetUserById: (state) => {
      state.isGetUserByIdLoading = false;
      state.isGetUserByIdError = false;
      state.isGetUserByIdSuccess = false;
      state.getUserByIdErrorMessage = "";
    },
    resetGetAllUsers: (state) => {
      state.isGetAllUsersLoading = false;
      state.isGetAllUsersError = false;
      state.isGetAllUsersSuccess = false;
      state.getAllUsersErrorMessage = "";
    },
    // resetUserDetails: (state) => {
    //   state.isDetailsLoading = false;
    //   state.isDetailsError = false;
    //   state.isDetailsSuccess = false;
    //   state.detailsErrorMessage = "";
    // },
    logout: (state) => {
      state.userInfo = null;
      localStorage.removeItem("userInfo");
      document.location.href = "/login";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state) => {
        state.isCreateLoading = true;
        state.isCreateError = false;
        state.isCreateSuccess = false;
        state.createErrorMessage = "";
      })
      .addCase(createUser.fulfilled, (state) => {
        state.isCreateLoading = false;
        state.isCreateError = false;
        state.isCreateSuccess = true;
        state.createErrorMessage = "";
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isCreateLoading = false;
        state.isCreateError = true;
        state.isCreateSuccess = false;
        state.createErrorMessage = action.payload
          ? action.payload
          : action.error.message;
      })
      .addCase(loginUser.pending, (state) => {
        state.isLoginLoading = true;
        state.isLoginError = false;
        state.isLoginSuccess = false;
        state.loginErrorMessage = "";
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoginLoading = false;
        state.isLoginError = false;
        state.isLoginSuccess = true;
        state.loginErrorMessage = "";

        state.userInfo = action.payload;
        localStorage.setItem("userInfo", JSON.stringify(action.payload));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoginLoading = false;
        state.isLoginError = true;
        state.isLoginSuccess = false;
        state.loginErrorMessage = action.payload;
      })
      .addCase(updateUser.pending, (state) => {
        state.isUpdateLoading = true;
        state.isUpdateError = false;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = "";
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = false;
        state.isUpdateSuccess = true;
        state.updateErrorMessage = "";

        // state.userInfo = action.payload;
        // localStorage.setItem("userInfo", JSON.stringify(action.payload));
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = true;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = action.payload;
      })
      .addCase(getUserById.pending, (state) => {
        state.isGetUserByIdLoading = true;
        state.isGetUserByIdError = false;
        state.isGetUserByIdSuccess = false;
        state.getUserByIdErrorMessage = "";
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.isGetUserByIdLoading = false;
        state.isGetUserByIdError = false;
        state.isGetUserByIdSuccess = true;
        state.getUserByIdErrorMessage = "";

        state.selectedUser = action.payload;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.isGetUserByIdLoading = false;
        state.isGetUserByIdError = true;
        state.isGetUserByIdSuccess = false;
        state.getUserByIdErrorMessage = action.payload;
      })
      .addCase(getAllUsers.pending, (state) => {
        state.isGetAllUsersLoading = true;
        state.isGetAllUsersError = false;
        state.isGetAllUsersSuccess = false;
        state.getAllUsersErrorMessage = "";
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.isGetAllUsersLoading = false;
        state.isGetAllUsersError = false;
        state.isGetAllUsersSuccess = true;
        state.getAllUsersErrorMessage = "";

        state.users = action.payload;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.isGetAllUsersLoading = false;
        state.isGetAllUsersError = true;
        state.isGetAllUsersSuccess = false;
        state.getAllUsersErrorMessage = action.payload;
      });
  },
});

export const {
  resetUserCreate,
  resetUserLogin,
  resetUserUpdate,
  logout,
  resetGetAllUsers,
  resetGetUserById,
} = userSlice.actions;

export default userSlice.reducer;
